<template>
  <div class="fx-row-center mini-pagination-box">
    <div @click="handleCurrentChange(-1)" class="icon-btn" >
      <i class="el-icon-d-arrow-left min-pagination-icon" :class="{'disable-btn': currentPage <= 1}"></i>
    </div>
    <div class="pagesize-box">{{currentPage}}/{{pageCount}}页</div>
    <div @click="handleCurrentChange(1)" class="icon-btn" >
      <i class="el-icon-d-arrow-right min-pagination-icon" :class="{'disable-btn': currentPage >= pageCount}"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      let page = this.currentPage + val;
      if (page < 1 || page > this.pageCount) {
        return;
      }
      this.$emit("current-change", page);
    }
  }
};
</script>

<style lang="less" scoped>
.mini-pagination-box {
  width: 120px;
  .pagesize-box {
    white-space: nowrap;
  }
  .icon-btn {
    padding: 0px 10px;
    &:hover {
      cursor: pointer;
    }
  }
  .min-pagination-icon {
    color: black;
  }
  .disable-btn {
    color: gray;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/pagination/mini-pagination.vue